import React,{useState} from 'react'

import ImageDrawModal from "../canvas/ImageDrawModal";
import ImageDrawCard from "../canvas/ImageDrawCard";

import thumb12 from '../images/thumb_12.jpg';
import thumb13 from '../images/thumb_13.jpg';

import img12 from '../images/12.png';
import img13 from '../images/13.png';

import "./modal.css"

export default function Pathology(){
    const [show,setShow] = useState(false);
    const [title,setTitle] = useState("Eye Lids");
    const [showImage,setShowImage] = useState(img12);
 
    const handleShow = (subtitle,imagename)=>{
         setTitle(subtitle)
         setShowImage(imagename)
         setShow(true)
    }

    const cards = [
        { title: "Pathology Eyelids - Blepharitis", thumb: thumb12, image: img12 },
        { title: "Pathology Eyelids - Stye/Hordeolum", thumb: thumb13, image: img13 },
    ]
    return(
        <>
            <div className="card shadow-sm border-0 mb-4">
                <div className="card-body py-4">
                    {/* Heading */}
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h3 className="h5 fw-bold mb-0">Pathology Eyelids</h3>
                    </div>

                    {/* Gallery */}
                    <div className="row g-4 row-cols-2 row-cols-md-3 row-cols-lg-5">
                        {cards.map((c, i) => (
                            <ImageDrawCard
                                key={i}
                                title={c.title}
                                thumb={c.thumb}
                                image={c.image}
                                onClick={handleShow}
                            />
                        ))}

                    </div>
                </div>
            </div>
            {/* Reusable modal */}
            {showImage && (
                <ImageDrawModal
                    show={show}
                    title={title}
                    image={showImage}
                    onClose={() => setShow(false)}
                />
            )}
        </>
    )
}